import React from "react"
import PropTypes from "prop-types"
import { Row, Col, FormGroup } from "reactstrap"

import SimpleBar from "simplebar-react"

import { Link } from "react-router-dom"

import "../../components/CommonForBoth/rightbar.scss"
import AddNewCategory from "../Product/AddNewCategory"
import AddNewSubCategory from "../Product/AddNewSubCategory"
import AddNewHSN from "../Product/AddNewHSN"
import AddNewUnit from "../Product/AddNewUnit"
import AddNewTax from "../Product/AddNewTax"
import AddNewSupplier from "../Product/AddNewSupplier"
import AddNewBrand from "../Product/AddNewBrand"
import AddNewManufacturer from "../Product/AddNewManufacturer"
import AddNewColour from "../Product/AddNewColour"
import AddNewSize from "../Product/AddNewSize"
import AddNewCustomer from "../Product/AddNewCustomer"
import AddNewCOA from "../Product/AddNewCOA"
import AddNewEmployee from "../Product/AddNewEmployee"
import AddNewBank from "../Product/AddNewBank"


//Import images


const RightDrawer = props => {
  const onCloseRightBar = () => {
    const { onClose } = props
    if (onClose) {
      onClose()
    }
  }

  const newlyAddedValue = (value) => {
    props.onNewlyAddedValue(value)
    if(value > 0){
      props.onClose()
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ height: "900px" }}>
        <div data-simplebar className="h-100">
          <div className="rightbar-title px-3 py-4">
            <Link
              to="#"
              onClick={e => {
                onCloseRightBar()
              }}
              className="right-bar-toggle float-end"
            >
              <i className="mdi mdi-close noti-icon" />
            </Link>
            <h5 className="m-0">{props.isEdit===true?'Edit ':'Add new '}  {props.currentItem}</h5>
          </div>

          <hr className="my-0" />

          {props.currentItem == 'Category' ? <AddNewCategory newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewCategory> : null}
          {props.currentItem == 'Sub Category' ? <AddNewSubCategory newlyAddedValue={newlyAddedValue} selectedId={props.selectedId} categorySubCategoryMap={props.categorySubCategoryMap} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewSubCategory> : null}
          {props.currentItem == 'HSN' ? <AddNewHSN newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewHSN> : null}
          {props.currentItem == 'Unit' ? <AddNewUnit newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewUnit> : null}
          {props.currentItem == 'Tax' ? <AddNewTax newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewTax> : null}
          {props.currentItem == 'Supplier' ? <AddNewSupplier newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewSupplier> : null}
          {props.currentItem == 'Brand' ? <AddNewBrand newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewBrand> : null}
          {props.currentItem == 'Manufacturer' ? <AddNewManufacturer newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewManufacturer> : null}
          {props.currentItem == 'Colour' ? <AddNewColour newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewColour> : null}
          {props.currentItem == 'Size' ? <AddNewSize newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewSize> : null}
          {props.currentItem == 'Customer' ? <AddNewCustomer newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewCustomer> : null}
          {props.currentItem == 'Account' ? <AddNewCOA newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewCOA> : null}
          {props.currentItem == 'Employee' ? <AddNewEmployee newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewEmployee> : null}
          {props.currentItem == 'Bank' ? <AddNewBank newlyAddedValue={newlyAddedValue} detailsForEdit={props.detailsForEdit} isEdit={props.isEdit} enteredText={props.enteredText}></AddNewBank> : null}
          
          
          <div className="p-4">


          </div>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

RightDrawer.propTypes = {
  onClose: PropTypes.func,
  onNewlyAddedValue: PropTypes.func,
  currentItem: PropTypes.any,
  categorySubCategoryMap: PropTypes.any,
  selectedId: PropTypes.any,
  detailsForEdit: PropTypes.any,
  isEdit: PropTypes.bool,
  enteredText:PropTypes.any,
}

export default RightDrawer
